module.exports = __webpack_public_path__ + "static/media/intro@2x.7824534b.png";